import { ArrowDown, ArrowUp } from 'lucide-react';

export const VDLLevel0TableArrowPosition = ({
  posLoc,
  position
}: {
  posLoc: number;
  position: number;
}) => {
  if (posLoc > 0)
    return (
      <span className="flex items-center gap-1 font-semibold text-zinc-700 dark:text-white">
        {position}
        <ArrowUp className="h-4 w-4" />
      </span>
    );
  else if (posLoc < 0)
    return (
      <span className="flex items-center gap-1 font-semibold text-zinc-700 dark:text-white">
        {position}
        <ArrowDown className="h-4 w-4" />
      </span>
    );
};
